import styled from 'styled-components'

export const Checkbox = styled.label`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  margin-bottom: 10px;

  & + label {
    margin-top: 10px;
  }
`

export const Input = styled.input`
  appearance: none;
  cursor: pointer;
  border: 2px solid #dfe0e7;
  width: 18px;
  height: 18px;
  padding: 0;
  margin: 4px 7px 0 0;
  border-radius: 4px;

  &:checked {
    border: 0;
    background-color: #f3123c;
    background-image: url('/assets/img/icon/check-white.svg');
    background-position: center;
    background-repeat: no-repeat;
  }
`

export const FilterText = styled.p`
  color: #2e2d37;
  font-weight: 500;
`

export const Badge = styled.img`
  width: 15px;
  height: auto;
  margin-left: 7px;
`

export const Description = styled.span`
  font-size: 12px;
  color: #aeaeba;
  font-weight: 500;
  line-height: 150%;
`

export const WrapperContent = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  width: 100%;
`

export const WrapperTitle = styled.div`
  display: flex;
  align-items: center;
  min-height: 27px;
`
